'use strict';

import "@babel/polyfill";
import 'slick-carousel';
import { ua } from './view/_ua';
import { header } from './view/_header';
import { slider } from './view/_slider';
import { accordion } from './view/_accordion';
import { toTop } from './view/_toTop';
